module.exports = Promise.resolve(parcelRequire("9FEJa"))